import React, { useState } from 'react'
import Layout from 'shared/layouts/containers/Main'
import { Button, Form, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { roles, settings } from 'consts'
import hasAnyRole from 'shared/utils/hasAnyRole'
import HeaderCustomerSelect from 'containers/HeaderCustomerSelect'
import InputWrapper from 'shared/components/InputWrapper'
import resSettings from './resolvers/resSettings'
import useInit from './hooks/useInit'
import useFocusError from 'shared/hooks/useFocusError'
import submitForm from './utils/submitForm'
import SelectWrapper from 'shared/components/SelectWrapper'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import prepareSubmitForm from './utils/prepareSubmitForm'
import { pageSizes } from 'consts'
import showCustomerSwitcher from 'utils/showCustomerSwitcher'

const Settings: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [dataLoaded, setDataLoaded] = useState<boolean>(false)

  const submitRef = React.createRef<HTMLButtonElement>()

  const [pageSizesObj, setPageSizesObj] = useState<any>([])
  const [currentCustomer, setCurrentCustomer] = useState<{} | null>({})

  const isSuperAdmin: boolean = hasAnyRole([roles.superAdmin])

  const {
    control,
    handleSubmit,
    setFocus,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: resSettings,
  })

  useInit({
    pageSizes,
    setDataLoaded,
    setShowOverlay,
    setPageSizesObj,
    setValue,
  })

  useFocusError({
    errors,
    setFocus,
  })

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showOverlay={showOverlay}
      showCardHeader={true}
      showMinimizedBarButton={true}
      headerInsert={
        showCustomerSwitcher() ? (
          <HeaderCustomerSelect
            setShowOverlay={setShowOverlay}
            handleCustomerChanged={(customer) => {
              setCurrentCustomer(customer)
              setShowOverlay(false)
            }}
          />
        ) : undefined
      }
      actionInsert={
        <Button
          disabled={!dataLoaded}
          type='submit'
          name='save'
          className='btn-round btn-primary'
          onClick={() => {
            if (submitRef.current != null) {
              submitRef.current.click()
            }
          }}
        >
          Save
        </Button>
      }
    >
      <Form
        onSubmit={handleSubmit((data) =>
          prepareSubmitForm({
            submitForm,
            setError,
            data,
            setShowOverlay,
            name: 'Settings',
          }),
        )}
        id='main-form'
      >
        <InputWrapper
          label={'Devices - Records per Page'}
          name={settings.pageSizeDevices}
          errors={errors}
        >
          <SelectWrapper
            name={settings.pageSizeDevices}
            control={control}
            options={pageSizesObj}
            optionLabel='name'
            optionValue='id'
            defaultValue={null}
            placeholder='Select Records per Page...'
          />
        </InputWrapper>

        <InputWrapper
          label={'Users - Records per Page'}
          name={settings.pageSizeUsers}
          errors={errors}
        >
          <SelectWrapper
            name={settings.pageSizeUsers}
            control={control}
            options={pageSizesObj}
            optionLabel='name'
            optionValue='id'
            defaultValue={null}
            placeholder='Select Records per Page...'
          />
        </InputWrapper>

        <InputWrapper
          label={'Sites - Records per Page'}
          name={settings.pageSizeSites}
          errors={errors}
        >
          <SelectWrapper
            name={settings.pageSizeSites}
            control={control}
            options={pageSizesObj}
            optionLabel='name'
            optionValue='id'
            defaultValue={null}
            placeholder='Select Records per Page...'
          />
        </InputWrapper>

        <InputWrapper
          label={'Cost Centers - Records per Page'}
          name={settings.pageSizeCostCenters}
          errors={errors}
        >
          <SelectWrapper
            name={settings.pageSizeCostCenters}
            control={control}
            options={pageSizesObj}
            optionLabel='name'
            optionValue='id'
            defaultValue={null}
            placeholder='Select Records per Page...'
          />
        </InputWrapper>

        {isSuperAdmin && (
          <InputWrapper
            label={'Superadmins - Records per Page'}
            name={settings.pageSizeSuperadmins}
            errors={errors}
          >
            <SelectWrapper
              name={settings.pageSizeSuperadmins}
              control={control}
              options={pageSizesObj}
              optionLabel='name'
              optionValue='id'
              defaultValue={null}
              placeholder='Select Records per Page...'
            />
          </InputWrapper>
        )}
        <Button type='submit' name='save' ref={submitRef} className='d-none'></Button>
      </Form>
    </Layout>
  )
}

export default Settings
